<div class="component-wrapper p-12" style="padding-right: 0px !important; padding-left: 0px !important;">
    <mat-card>
        <mat-card-header class="mb-20 ">
            <mat-card-title style="font-size: 1rem;">Symptoms & Social / Risk Factors</mat-card-title>
            @if(!editMode){
            <mat-card-subtitle class="mb-20 subtitle-text-color-2 small-subtitle">
                Add items by selecting a category and submitting the form. Each submission adds an entry below.
            </mat-card-subtitle>
            }@else {
            <mat-card-subtitle class="mb-20 subtitle-text-color-2 small-subtitle">
                Patient Complaint and Risk Factors

            </mat-card-subtitle>
            }
        </mat-card-header>

        @if(!editMode){
        <mat-card-content>
            <!-- {{currentValues | json}} -->
            @if(!editMode && !isPatient){
            <div class="g-just-flex gap-20 mb-20" style="align-items: unset">
                <!--2 rich button structure-->
                <button style="font: inherit;" [ngClass]="{
                    'selected': currentValues?.category?.[0]?.coding?.[0]?.code === 'exam',
                    'rich-button': true
                }" (click)="setCategory('exam')">
                    <div class="g-just-flex" style="flex-direction: column; align-items: flex-start;
                    justify-content: flex-start;
                    font: inherit; height: 100%;
                    ">
                        <div class="top-label">
                            <div class="rich-button-icon">
                                <mat-icon>healing</mat-icon>
                            </div>
                            <div class="rich-button-text">
                                Symptoms
                            </div>
                        </div>
                        <div class="bottom-label small-subtitle">
                            Physical symptoms reported by the patient.
                        </div>
                    </div>
                    <div class="circle-marker-fill"></div>

                </button>
                <button style="font: inherit;" [ngClass]="{
                    'selected': currentValues?.category?.[0]?.coding?.[0]?.code === 'social-history',
                    'rich-button': true
                }" (click)="setCategory('social-history')">
                    <div class="g-just-flex" style="flex-direction: column; align-items: flex-start;
                    justify-content: flex-start;
                    font: inherit;
                    ">
                        <div class="top-label">
                            <div class="rich-button-icon">
                                <mat-icon>people</mat-icon>
                            </div>
                            <div class="rich-button-text">
                                Social / Risk Factors
                            </div>
                        </div>
                        <div class="bottom-label subtitle-text-color-2 small-subtitle">
                            Define the patient's occupational, personal (e.g., lifestyle), social, familial, and
                            environmental history and health risk factors that may impact the patient's health.
                        </div>
                    </div>
                    <div class="circle-marker-fill"></div>
                </button>
            </div>
            }




            <div class="spacer-20"></div>
            <!-- {{currentValues | json}} -->
            @if(currentValues?.category?.[0]?.coding?.[0]?.code === 'exam'){
            <app-dynamic-forms-v2 [formFields]="this.allFieldsForSymptoms" [formMetaData]="symptomsFormMetaData" [resetOnSubmit]="false"
                (formSubmitted)="submitFromDynamicForm($event, dy)" #dy></app-dynamic-forms-v2>


            }@else if(currentValues?.category?.[0]?.coding?.[0]?.code === 'social-history'){
            <app-dynamic-forms-v2 [formFields]="this.allFieldsForRiskFactors" [resetOnSubmit]="false"
                [formMetaData]="this.riskFactorsFormMetaData" #dy
                (formSubmitted)="submitFromDynamicForm($event, dy)"></app-dynamic-forms-v2>
            }
        </mat-card-content>

        <mat-divider></mat-divider>
        <div class="py-20"></div>
        }
        @if(fields.length === 0){
        @if(!editMode){
        <div class="small-subtitle subtitle-text-color-2 p-15">
            No items added yet.
        </div>
        }
        }@else{
        <mat-accordion class="symptom-array" multi style="align-items: unset;">
            @for(group of fields.controls; track $index){
            <div style="flex:1 1 max-content; margin-bottom: 10px;" [ngClass]="{
'bg-primary': getCategoryCodeFromGroup(group) === 'exam',
                                'bg-accent': getCategoryCodeFromGroup(group) === 'social-history'
                         
            }">
                <mat-expansion-panel class="w-100">
                    <mat-expansion-panel-header style="height:max-content">
                        <mat-panel-title class="g-just-flex gap-10 py-8" style="justify-content: flex-start;">
                            <mat-icon class="me-4" [ngClass]="
                            {
                             'me-4': true,   
                                'text-primary': getCategoryCodeFromGroup(group) === 'exam',
                                'text-accent': getCategoryCodeFromGroup(group) === 'social-history'
                            }
                            ">{{ getCategoryIconFromGroup(group) }}</mat-icon>
                            <span>{{ getCodeDisplayFromGroup(group) |
                                titlecase}}
                                <span class="spacer ms-12"></span>
                                <span [appEmphasis]="getCategoryLabelFromGroup(group).toLowerCase()" [fontSize]="'13px'"
                                    [opacity]="0.6" [showBorder]="false">
                                    {{ getCategoryLabelFromGroup(group) | titlecase}}
                                </span>
                                <span class="me-6"></span>
                                <!--badge o determine if it's cheif complaint-->
                                @if (getIsChiefComplaintFromGroup(group) === true) {
                                <span [appEmphasis]="'chief-complaint'" [fontSize]="'13px'" [opacity]="0.6"
                                    [showBorder]="false">
                                    Chief complaint
                                </span>
                                }
                            </span>
                        </mat-panel-title>
                        <!-- <mat-panel-description>
                            {{ getValueSummaryFromGroup(group) }}
                        </mat-panel-description> -->
                    </mat-expansion-panel-header>

                    <div class="g-just-flex gap-10" style="justify-content: flex-end;">
                        @if(!isPatient) {
                        <button mat-button (click)="editObservationAtIndex($index)">
                            <mat-icon style="vertical-align: middle; font-size: 16px;
                            height: 16px;">edit</mat-icon>
                            Edit
                        </button>
                        }
                        @if(editMode && !isPatient){
                        <button mat-button (click)="changeStatusAtIndex($index)">
                            <mat-icon style="vertical-align: middle; font-size: 16px;
                            height: 16px;">swap_horiz</mat-icon>
                            Status
                        </button>
                        }
                    </div>

                    <div class="spacer-10"></div>

                    @if(getCategoryCodeFromGroup(group) === 'exam'){
                    <div class="kv-grid w-100" style="max-width: max-content;">
                        <div class="group-of-keyAndvalue g-just-flex">
                            <div class="kv-label">{{ symptomsMaskedLabelMap.name }}</div>
                            <div class="kv-value">{{ (getCodeDisplayFromGroup(group) || '—') | titlecase }}</div>
                        </div>
                        <div class="group-of-keyAndvalue g-just-flex">
                            <div class="kv-label">{{ symptomsMaskedLabelMap.value }}</div>
                            <div class="kv-value">
                                @if(isSeverityValue(getValueSummaryFromGroup(group))){
                                <span [appEmphasis]="getValueSummaryFromGroup(group)" [fontSize]="'13px'">
                                    {{ getValueSummaryFromGroup(group) | titlecase }}
                                </span>
                                } @else {
                                {{ (getValueSummaryFromGroup(group) || '—') | titlecase }}
                                }
                            </div>
                        </div>
                        <div class="group-of-keyAndvalue g-just-flex">
                            <div class="kv-label">
                                {{ symptomsMaskedLabelMap.effectivePeriod }}
                            </div>
                            <div class="kv-value">
                                <div class="wrapper g-just-flex flex-column">




                                    <div class="top g-just-flex gap-4">
                                        <span>
                                            {{
                                            getEffectivePeriodDisplayFromGroup(group).start?(getEffectivePeriodDisplayFromGroup(group).start
                                            | date) :'-' }}
                                        </span>
                                        @if(getEffectivePeriodDisplayFromGroup(group).end ||
                                        getEffectivePeriodDisplayFromGroup(group).start
                                        ){
                                        @if(getEffectivePeriodDisplayFromGroup(group).start &&
                                        !getEffectivePeriodDisplayFromGroup(group).end){
                                        <div class="bottom subtitle-text-color-2">
                                            → Ongoing
                                        </div>
                                        }@else if(getEffectivePeriodDisplayFromGroup(group).end &&
                                        getEffectivePeriodDisplayFromGroup(group).start
                                        ){
                                        <div class="g-just-flex ms-8 gap-8">
                                            <span>→</span>
                                            <div class="g-just-flex flex-column">

                                                {{ getEffectivePeriodDisplayFromGroup(group).end | date : 'mediumDate'
                                                }}

                                            </div>
                                        </div>
                                        }

                                        }
                                    </div>
                                    @if(getEffectivePeriodDisplayFromGroup(group).start &&
                                    getEffectivePeriodDisplayFromGroup(group).end){
                                    <div class="bottom-subtitle-text-color-2">
                                        <div [appEmphasis]="getDurationFromEffectivePeriodFromGroup(group)">
                                            {{ getDurationFromEffectivePeriodFromGroup(group) }}
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <!-- <div class="kv-label">Status</div>
                        <div class="kv-value">{{ group.get('status')?.value || '—' }}</div> -->
                    </div>
                    }@else if(getCategoryCodeFromGroup(group) === 'social-history'){
                    <div class="kv-grid w-100" style="max-width: max-content;">
                        <div class="group-of-keyAndvalue g-just-flex">
                            <div class="kv-label">{{ riskFactorMaskedLabelMap.name }}</div>
                            <div class="kv-value">{{ (getCodeDisplayFromGroup(group) || '—') | titlecase }}</div>
                        </div>
                        <div class="group-of-keyAndvalue g-just-flex">
                            <div class="kv-label">{{ riskFactorMaskedLabelMap.value }}</div>
                            <div class="kv-value">
                                @if(isSeverityValue(getValueSummaryFromGroup(group))){
                                <span [appEmphasis]="getValueSummaryFromGroup(group)" [fontSize]="'13px'">
                                    {{ getValueSummaryFromGroup(group) | titlecase }}
                                </span>
                                } @else {
                                {{ (getValueSummaryFromGroup(group) || '—') | titlecase }}
                                }
                            </div>
                        </div>

                        <!-- <div class="kv-label">Status</div>
                        <div class="kv-value">{{ group.get('status')?.value || '—' }}</div> -->
                    </div>
                    }@else{
                    <div class="kv-grid">
                        <div class="kv-label">Name</div>
                        <div class="kv-value">{{ (getCodeDisplayFromGroup(group) || '—') | titlecase }}</div>
                        <div class="kv-label">Value</div>
                        <div class="kv-value">{{ (getValueSummaryFromGroup(group) || '—') | titlecase }}</div>
                    </div>
                    }

                </mat-expansion-panel>
            </div>
            }
        </mat-accordion>

        <!-- submit all button -->
        @if(!hideSubmitAction) {
          @if(!editMode && !isPatient){
          <button mat-flat-button (click)="addSystemGeneratedValuesAndSubmit()">Submit All </button>
          } @else if (canUpdateAll && !isPatient) {
          <button mat-flat-button (click)="addSystemGeneratedValuesAndSubmit()">Update All </button>
          }
        }
        }
    </mat-card>
</div>